import { IncomingMessage } from 'http'

import { DocumentStatus } from '../types'
import {
  shouldBlockDocument,
  ShouldBlockDocument_Document,
  ShouldBlockDocument_Viewer,
} from './should-block-document'

export type GetDocumentStatusCode_Document = ShouldBlockDocument_Document & {
  artifact: string | null
  status: string | null
  isActive: boolean | null
}

export type GetDocumentStatusCode_Viewer = ShouldBlockDocument_Viewer | null

export function getDocumentStatusCode(
  req: IncomingMessage,
  document: GetDocumentStatusCode_Document,
  viewer: GetDocumentStatusCode_Viewer,
  options: { checkBlockDocument?: boolean } = {
    checkBlockDocument: true,
  }
): number {
  if (document.status === DocumentStatus.REMOVIDO) {
    return 410
  }
  if (!document.isActive) {
    return 401
  }
  if (options.checkBlockDocument && shouldBlockDocument(req, document, viewer)) {
    return 429
  }
  return 200
}
